import React, { useState } from "react";
import "./Head.css"; // لو Video محتاج Head2.css بدلها
import ScrollProgressBar from "../../../componant/ScrollProgressBar";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";

const Head = ({ darkMode, toggleDarkMode }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) return;

    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/logout`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      localStorage.clear();
      navigate("/");
    } catch (error) {
      navigate("/login");
    }
  };

  // ====================== 🔥 ROUTE-BASED UI ======================
  const hasToken = !!localStorage.getItem("authToken");

  // 📌 1 — صفحة PricingCard
  if (location.pathname === "/PricingCard") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/")}
              />           
               <a onClick={() => navigate("/")}>الرئيسيه</a>

               </div>

            <div className="buttons">
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
              <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}

              </button>
            </div>
          </div>
        </section>
        <ScrollProgressBar />
      </>
    );
  }

  // 📌 2 — صفحة ProfileCard
  if (location.pathname === "/ProfileCard") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/")}
              />       
               <a onClick={() => navigate("/")}>الرئيسيه</a>

                   </div>

            <div className="buttons">
            <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </button>
              
              <button
                onClick={() => navigate("/PricingCard")}
                className="btn login"
              >
              جميع المحاضرات
              </button>
              <button
                onClick={() => navigate("/MySubscriptions")}
                className="btn login"
              >
دروسي
              </button>
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
            </div>
          </div>
        </section>
        <ScrollProgressBar />
      </>
    );
  }

  // 📌 3 — صفحة Video  🔥🔥
  if (location.pathname === "/Video") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/")}
              />     
               <a onClick={() => navigate("/")}>الرئيسيه</a>

                     </div>

            <div className="buttons">
            <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </button>
            

              <button
                onClick={() => navigate("/ProfileCard")}
                className="btn login"
              >
                المحاضرات
              </button>
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
            </div>
          </div>
        </section>

        <ScrollProgressBar />
      </>
    );
  }

  if (location.pathname === "/MySubscriptions") {
    return (
      <>
        <section className="head">
          <div className="container flexSB">
            <div className="left-logo">
              <img
                src="/images/logos.jpg"
                alt="Logo"
                className="logo-img"
                onClick={() => navigate("/")}
              />         
              
              <a onClick={() => navigate("/")}>الرئيسيه</a>
              </div>
            <div className="buttons">
            <button onClick={toggleDarkMode} className="btn darkmode">
                {darkMode ? "☀️ Light" : "🌙 Dark"}
              </button>

              <button
                onClick={() => navigate("/Teachers")}
                className="btn login"
              >
                مدرسيني 
              </button>
              {/* <button
                onClick={() => navigate("/PricingCard")}
                className="btn login"
              >
                جميع المحاضرات 
              </button> */}
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
            </div>
          </div>
        </section>

        <ScrollProgressBar />
      </>
    );
  }

  // 📌 4 — الصفحات العادية (Default Header)
  return (
    <>
      <section className="head">
        <div className="container flexSB">
          <div className="left-logo">
            <img
              src="/images/logos.jpg"
              alt="Logo"
              className="logo-img"
              onClick={() => navigate("/")}
            />       
             <a onClick={() => navigate("/")}>الرئيسيه</a>

               </div>

          <div className="buttons flex items-center gap-2">

            <button onClick={toggleDarkMode} className="btn darkmode">
              {darkMode ? "☀️ Light" : "🌙 Dark"}
            </button>

            {!hasToken 
            ? 
            (
              <>
                <button onClick={() => navigate("/Signup")} className="btn signup">
                  إنشئ حسابك
                </button>

                <button onClick={() => navigate("/Login")} className="btn login">
                  تسجيل الدخول
                </button>
              </>
            ) 
            : 
            (
              <>

              <button onClick={() => navigate("/MySubscriptions")} className="btn login">
                دروسي
              </button>
              <button onClick={handleLogout} className="btn signup">
                تسجيل الخروج
              </button>
              </>

            )}
              

          </div>

        </div>
      </section>

      <ScrollProgressBar />
    </>
  );
};

export default Head;
